import { TaskAttachment, TaskDataType } from "@/domain/task";
import globalStore from "./store/globalStore";

export const getTaskById = (taskId: number): TaskDataType | null => {
    const tasks = globalStore.getters.getTasks as TaskDataType[];
    return tasks.find((task: TaskDataType) => task.id === taskId) || null;
}

export const getAttachmentById = (id: number) => {
    const attachments = globalStore.getters.getTask.attachments as TaskAttachment[];
    return attachments.find(x => x.id === id);
}